@if (items().length) {
<div class="legend">
    <ul>
        @for (item of items(); track item.label; let i = $index) {
        <li class="legend-item" [class.selected]="selectedIndex() === i">
            <span class="legend-item-color" [style.background-color]="item.color"></span>
            {{item.label}}
        </li>
        }
    </ul>
</div>
}
